import Axios from '../Axios';
import { fetchUser } from '../utils/fetchUser';

export const getSolicitudes = async () => {
    try {
      const userInfo = fetchUser();
      
      const {data}  = await Axios.get(
        `/solicitudes?empresa=${userInfo.empresa}`);
       // console.log(" DATOS " + JSON.stringify(data));
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const crearSolicitud = async (clienteData) => {
    try {
      const userInfo = fetchUser();
      clienteData.empresa = userInfo.empresa;

        const {data}  = await Axios.post(
            '/solicitudes', clienteData
        );
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const crearSolicitudExcel = async (solData) => {
    try {

        const {data}  = await Axios.post(
            '/solicitudes/masivo', solData
        );
        return  data;
    } catch (error) {
      return Promise.reject(error);
    }
  };

  export const updateSolicitud = async (clienteData) => {
    try {
      const userInfo = fetchUser();
      clienteData.empresa = userInfo.empresa;
      
        const {data}  = await Axios.patch(
          `/solicitudes/${clienteData._id}`, clienteData
        );

        return  data;
      } catch (error) {
        return Promise.reject(error);
      }
  };

  export const updateEstadoSolicitud = async (clienteData) => {
    try {

      
        const {data}  = await Axios.patch(
          `/solicitudes/estado/${clienteData._id}`, clienteData
        );

        return  data;
      } catch (error) {
        return Promise.reject(error);
      }
  };

  export const updateSelectedEquipo = async (clienteData) => {
    try {

        const {data}  = await Axios.patch(
          `/solicitudes/selectedequipo/${clienteData._id}`, clienteData
        );
        return  data;
      } catch (error) {
        return Promise.reject(error);
      }
  };

  export const updateFechaEnObra = async (clienteData) => {
    try {

        const {data}  = await Axios.patch(
          `/solicitudes/fechaenobra/${clienteData._id}`, clienteData
        );
        return  data;
      } catch (error) {
        return Promise.reject(error);
      }
  };

  export const updateSelectedEquipoFinaliza = async (clienteData) => {
    try {

        const {data}  = await Axios.patch(
          `/solicitudes/finaliza/${clienteData._id}`, clienteData
        );
        return  data;
      } catch (error) {
        return Promise.reject(error);
      }
  };

  export const deleteSolicitud = (Id) => Axios.delete(`/solicitudes/${Id}`);

  export const getSolicitudesFiltros = async ( fechaStart,fechaEnd , tipoSolicitud,estado, numeroSolicitud, centroCosto) => {
    try {
    const userInfo = fetchUser();

    const {data}  = await Axios.get(
        `/solicitudes?empresa=${userInfo.empresa}&fechaStart=${fechaStart}&fechaEnd=${fechaEnd}&tipoSolicitud=${tipoSolicitud}&estado=${estado}&numeroSolicitud=${numeroSolicitud}&centroCosto=${centroCosto}`);
        return  data;
    } catch (error) {
    return Promise.reject(error);
    }
  };
